import ApiClient from './ApiClient';

class DashboardAppsAPI extends ApiClient {
  constructor() {
    super('dashboard_apps', { accountScoped: true });
  }

  checkEmbeddable(url) {
    return axios.post(`${this.url}/check_embeddable`, { url });
  }
}

export default new DashboardAppsAPI();
